import { useLayoutEffect, useState, type ReactNode } from 'react'
import { HomeHeader } from '@/shared/ui/AppHeader'
import { WideHeader } from '@/shared/ui/WideHeader'

export type LayoutTree = 'unified' | 'wide' | 'pc'

const TREE_CLASS: Record<LayoutTree, string> = {
  unified: 'mobile-screen tablet-screen md:[--wide-header-w:1120px]',
  wide: 'tablet-screen [&_.wide-header]:justify-center',
  pc: 'pc-scale hidden pc:block [&_.wide-header]:max-w-none [&_.wide-header]:justify-center',
}

type Props = {
  tree?: LayoutTree
  mobileTitle?: string
  className?: string
  children: ReactNode
}

const PC_BASE_WIDTH = 1120

function measurePcZoom(): number {
  const width = document.documentElement.clientWidth
  return width >= 768 && width < PC_BASE_WIDTH ? width / PC_BASE_WIDTH : 1
}

function usePcZoom(enabled: boolean): number {
  const [zoom, setZoom] = useState(() => (enabled ? measurePcZoom() : 1))

  useLayoutEffect(() => {
    if (!enabled) return
    const apply = () => setZoom(measurePcZoom())
    apply()
    window.addEventListener('resize', apply)
    return () => window.removeEventListener('resize', apply)
  }, [enabled])

  return zoom
}

export function DefaultLayout({ tree = 'unified', mobileTitle, className, children }: Props) {
  const zoom = usePcZoom(tree === 'pc')

  return (
    <div
      className={className === undefined ? TREE_CLASS[tree] : `${TREE_CLASS[tree]} ${className}`}
      {...(tree === 'pc' ? { style: { zoom } } : {})}
    >
      {tree === 'unified' && (
        <div className="head-mobile">
          <HomeHeader {...(mobileTitle !== undefined ? { title: mobileTitle } : {})} />
        </div>
      )}
      <div className="head-wide">
        <WideHeader />
      </div>
      {children}
    </div>
  )
}
